import colorConfigs from '../../configs/colorConfigs';

export const OdersPageStyles = {
    containerBox: {
      textAlign: 'center',
      mt: 4,
      display: 'flex',
      justifyContent: 'center',
      gap: 2,
    },
    card: {
      mb: 0,
      padding: 0,
      backgroundColor: colorConfigs.quaternary,
      borderRadius: '15px',
      boxShadow: 1,
      borderStyle:'solid',
      borderWidth:2,
      flex: 1,
    },
    cardContentLeft: {
      textAlign: 'left',
    },
    transactionBox: {
      mt: 4,
    },
    transactionList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
    transactionDateBox: {
      mb: 1,
    },
    transactionDate: {
      mb: 1,
      fontWeight: 'bold',
    },
    orderBox: {
      mb: 1,
    },
    orderCard: {
      mb: 1,
      p: 2,
      minHeight: 76,
      backgroundColor: colorConfigs.quaternary,
      borderRadius: '15px',
      boxShadow: 1,
      borderStyle: 'solid',
      borderWidth: 2,
      transition: 'box-shadow 0.2s ease, transform 0.2s ease',
      '&:hover': {
        boxShadow: 3,
        transform: 'translateY(-1px)',
      },
    },
    orderLink: {
      display: 'block',
      mb: 1,
      color: 'inherit',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: 'var(--color-overlay-black-04)',
      },
    },
    orderDetailsBox: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      pb:1,
    },
    orderIdText: {
      fontSize: '16px',
    },
    orderItemsText: {
      color: 'textSecondary',
    },
    paymentAmountText: {
      textAlign: 'right',
    },
    paymentDetailsText: {
      color: 'textSecondary',
    },
  };
  